/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { ReportCommentFormContainer_comment$ref } from "./ReportCommentFormContainer_comment.graphql";
declare const _ReportButtonContainer_comment$ref: unique symbol;
export type ReportButtonContainer_comment$ref = typeof _ReportButtonContainer_comment$ref;
export type ReportButtonContainer_comment = {
    readonly id: string;
    readonly viewerActionPresence: {
        readonly dontAgree: boolean;
        readonly flag: boolean;
    } | null;
    readonly " $fragmentRefs": ReportCommentFormContainer_comment$ref;
    readonly " $refType": ReportButtonContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ReportButtonContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewerActionPresence",
            "storageKey": null,
            "args": null,
            "concreteType": "ActionPresence",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dontAgree",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "flag",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ReportCommentFormContainer_comment",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'e69e0ef5b9c2b75fde6077282d38da15';
export default node;
